import { Box, Button, TextField, Typography, CircularProgress } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { startValidatePurchaseOrder } from '../../Redux/Slice/commonSlice'

const InventoryNotesBox = () => {
    const [reasonText, setReasonText] = useState("")
    const [maxTextLength, setMaxTextLength] = useState(200)

    const dispatch = useDispatch()
    const purchaseOrder = useSelector(state => state.common?.purchaseOrder)
    const isLoading = useSelector(state => state.common?.purchaseOrderLoading)
    const approverId = useSelector(state => state.common?.approverId)
    const approvalCode = useSelector(state => state.common?.approvalCode?.value)

    const handleTextChange = (e) => {
        if (e.target?.value?.length <= maxTextLength) {
            setReasonText(e.target?.value)
        }
    }

    const handleSubmit = () => {
        // Validate required reason for rejection
        if (!reasonText.trim()) {
            alert('Please provide a reason for rejection')
            return
        }

        const body = {
            actionType: 'rejected',
            rejectionReason: reasonText?.trim(),
            approverId: approverId,
            approvalCode: approvalCode
        }

        dispatch(startValidatePurchaseOrder({
            purchaseOrderId: purchaseOrder?._id,
            buildingId: purchaseOrder?.building,
            body
        }))
    }

    return (
        <Box sx={{
            display: 'flex',
            flexDirection: "column",
            alignItems: "center",
            width: '100%',
            maxWidth: { xs: '100%', sm: '400px', md: '480px' }
        }}>
            <Box sx={{
                display: 'flex',
                flexDirection: "column",
                width: '100%'
            }}>
                <TextField
                    id="outlined-multiline-flexible"
                    label="Reason to reject (Required)"
                    multiline
                    rows={2}
                    sx={{
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '12px',
                            bgcolor: '#fafbfc',
                            '&:hover fieldset': {
                                borderColor: '#f44336'
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: '#f44336',
                                borderWidth: '2px'
                            }
                        },
                        '& .MuiInputLabel-root.Mui-focused': {
                            color: '#f44336'
                        }
                    }}
                    value={reasonText}
                    onChange={handleTextChange}
                    required
                    error={!reasonText.trim()}
                />
                <Typography
                    sx={{
                        alignSelf: "flex-end",
                        mr: 1,
                        color: reasonText?.length === maxTextLength ? '#f44336' : '#6c757d',
                        fontWeight: 500,
                        fontSize: '0.8rem'
                    }}
                    variant='caption'
                >
                    {reasonText?.length}/{maxTextLength}
                </Typography>
            </Box>
            <Button
                sx={{
                    height: { xs: 35, md: 35 },
                    width: { xs: '20%', sm: '20%', md: '20%' },
                    bgcolor: '#F46326',
                    color: '#fff',
                    textTransform: 'none',
                    ":hover": {
                        bgcolor: '#F46326',
                    },
                    ":disabled": {
                        bgcolor: '#cccccc',
                        color: '#666666',
                        boxShadow: 'none'
                    }
                }}
                onClick={handleSubmit}
                disabled={isLoading || !reasonText.trim()}
                startIcon={isLoading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : null}
            >
                {isLoading ? 'Submitting...' : 'Submit'}
            </Button>
        </Box>
    )
}

export default InventoryNotesBox
